const dndItems = {
    sourceNode: "source",
    intermediateNode: "intermediate",
    finalNode: "final"
};

export default dndItems;
